export default "__VITE_ASSET__C6JDJ3IP__"